import { render, staticRenderFns } from "./weekReport.vue?vue&type=template&id=96752622&scoped=true"
import script from "./weekReport.vue?vue&type=script&lang=js"
export * from "./weekReport.vue?vue&type=script&lang=js"
import style0 from "./weekReport.vue?vue&type=style&index=0&id=96752622&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96752622",
  null
  
)

export default component.exports